{
  "CSServiceForms": {
    "wizard": {
      "steps": {
        "claimType": {
          "cashOption": {
            "long": {
              "description": "Delays over 4 hours on flights over 3,500km to or from a destination outside the EU<br>Cancellations for flights over 3,500km to or from destinations outside the EU with delays over 4 hours",
              "title": "€600 cash value"
            },
            "longHalf": {
              "description": "Delays of 3–4 hours on flights over 3,500km to or from a destination outside the EU<br>Cancellations for flights over 3,500km to or from a destination outside the EU with delays less than 4 hours",
              "title": "€300 cash value"
            },
            "middle": {
              "description": "Delays over 3 hours on flights of 1,500km or more within the EU or on flights between 1,500–3,500km outside the EU<br>Cancellations for flights of 1,500km or more within the EU or for flights between 1,500–3,500km outside the EU with delays over 3 hours",
              "title": "€400 cash value"
            },
            "middleHalf": {
              "description": " Cancellations for flights of 1,500km or more within the EU or for flights between 1,500–3,500km outside the EU with delays less than 3 hours ",
              "title": "€200 cash value"
            },
            "short": {
              "description": "Delays over 3 hours on flights less than 1,500km<br>Cancellations for flights less than 1,500km with delays over 2 hours ",
              "title": "€250 cash value"
            },
            "shortHalf": {
              "description": "Cancellations for flights less than 1,500km with delays less than 2 hours<br>Cancellations less than 7 days before the departure: This applies when the new departure time is more than 1 hour earlier than the originally scheduled time and the flight arrives at the final destination less than 2 hours before the originally scheduled arrival time.",
              "title": "€125 cash value"
            }
          }
        }
      }
    }
  },
  "NTServiceForms": {
    "fields": {
      "travelingWithAssistant": {
        "note": "Travelling with your own assistant is required if you need help taking medication, eating, using the toilet, standing up yourself, fitting an oxygen mask, or if you're unable to communicate about safety matters with our cabin crew."
      }
    },
    "specialAssistanceForm": {
      "additionalInformation": {
        "note": "Please note that we will not respond to inquiries related to other topics than special assistance and/or medical conditions via this form."
      },
      "consentToProcessingMedicalData": "By submitting this form, you give us your consent to process your medical data to handle and complete your service request. The consent also applies to our partners, if necessary.",
      "fileUploader": {
        "note": "Please attach the required additional files below before submitting your request (according to your reason for special assistance request marked above)."
      }
    }
  },
  "serviceForms": {
    "fields": {
      "state": {
        "required": "State is required"
      }
    }
  }
}
